import React from 'react'
import { Box, CircularProgress, Typography } from '@mui/material'

const BRAND_BG = '#0B0F1A'
const BRAND_CARD = 'rgba(20,25,40,0.9)'
const BRAND_ORANGE = '#FF8A00'
const BRAND_ORANGE_DARK = '#E67600'

const AnimatedLoader = () => {
    return (
        <Box
            sx={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                bgcolor: BRAND_BG,
            }}
        >
            <Box
                sx={{
                    textAlign: 'center',
                    background: BRAND_CARD,
                    px: 6,
                    py: 5,
                    borderRadius: 3,
                    border: '1px solid rgba(255,255,255,0.06)',
                    backdropFilter: 'blur(10px)',
                }}
            >
                <Box
                    sx={{
                        mb: 3,
                        position: 'relative',
                        width: 80,
                        height: 80,
                        mx: 'auto',
                    }}
                >
                    <CircularProgress
                        size={80}
                        thickness={4}
                        sx={{
                            color: BRAND_ORANGE,
                        }}
                    />

                    <Box
                        sx={{
                            position: 'absolute',
                            inset: 0,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontWeight: 800,
                            letterSpacing: 1,
                            color: BRAND_ORANGE,
                            fontSize: 20,
                        }}
                    >
                        MP
                    </Box>
                </Box>

                <Typography
                    variant="h6"
                    sx={{
                        mb: 1,
                        color: '#fff',
                        fontWeight: 700,
                    }}
                >
                    Loading MojoPayr…
                </Typography>

                <Typography
                    variant="body2"
                    sx={{
                        color: 'rgba(255,255,255,0.6)',
                    }}
                >
                    Please wait a moment.
                </Typography>
            </Box>
        </Box>
    )
}

export default AnimatedLoader